export default {
  CARD: 'card'
}
